import { Image } from '@zoomit/primitives';
import { Flex, Spacing } from '@zoomit/primitives';
import { Typography } from '@zoomit/zoomit-ds';

import { useWebKitCustomization } from '../../hooks/useWebKitCustomization';

type Props = {
  description?: string;
};

const NoResult = (props: Props) => {
  const { description } = props;

  const { noResult } = useWebKitCustomization((x) => x.emptyStatesPublicPath);

  return (
    <Flex alignItems="center" flexDirection="column" gap={Spacing.x} style={{ width: 'fit-content' }}>
      <Flex flexDirection="column" alignItems="center" gap={Spacing.x2}>
        {noResult && (
          <Image
            className={'object-contain'}
            width={noResult.width || 203}
            height={noResult.height || 208}
            src={noResult.publicSrc}
            alt="no result"
          />
        )}
        <Typography tag="p" fontSize={1.4} fontWeight="bold" lineHeight={2}>
          چیزی پیدا نشد!
        </Typography>
      </Flex>
      <Typography textAlign="center" tag="p" fontSize={1.3} lineHeight={1.85}>
        {description ?? 'دوباره جستجو کن'}
      </Typography>
    </Flex>
  );
};

export default NoResult;
